import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Components
import SignUpForm from '../../Forms/SignUpForm';
import SignInForm from '../../Forms/SignInForm';
import RecoveryPasswordFirstStepForm from '../../Forms/RecoveryPasswordFirstStepForm';
import RecoveryPasswordSecondStepForm from '../../Forms/RecoveryPasswordSecondStepForm';

// State
import { showPopup } from '../../../state/modules/popup';

export default function Forms() {
  const dispatch = useDispatch();
  const step = useSelector(state => state.popup.list.auth?.step);

  const goToSignIn = () => {
    return dispatch(showPopup('auth', { step: 'signIn' }));
  };

  const goToSignUp = () => {
    return dispatch(showPopup('auth', { step: 'signUp' }));
  };

  const goToRecoveryPasswordFirstStep = () => {
    return dispatch(showPopup('auth', { step: 'recoveryPassword/firstStep' }));
  };

  const goToRecoveryPasswordSecondStep = () => {
    return dispatch(showPopup('auth', { step: 'recoveryPassword/secondStep' }));
  };

  return (
    <>
      {step === 'signIn' && (
        <SignInForm goToRecoveryPassword={goToRecoveryPasswordFirstStep} goToSignUp={goToSignUp} />
      )}
      {step === 'signUp' && <SignUpForm onCancel={goToSignIn} />}
      {step === 'recoveryPassword/firstStep' && (
        <RecoveryPasswordFirstStepForm
          onCancel={goToSignIn}
          onNext={goToRecoveryPasswordSecondStep}
        />
      )}
      {step === 'recoveryPassword/secondStep' && (
        <RecoveryPasswordSecondStepForm
          goToSignIn={goToSignIn}
          onCancel={goToRecoveryPasswordFirstStep}
        />
      )}
    </>
  );
}
